
import { elk } from '@tencent/ppd-base-libs';
import { ref, watch } from '@vue/composition-api';

type ImgInfo = { href: string, endTime: number, };
// 图数量
const imgNums = ref(0);
// 图数组
const imgInfos = ref<ImgInfo[]>([]);

watch(imgInfos, (newArr) => {
  if (newArr.length === imgNums.value) {
    handleReport();
  }
})

export function setImgNums(num: number) {
  imgNums.value = num;
}

export function addImgInfo(info: ImgInfo) {
  imgInfos.value.push(info);
}

export function handleImgCostTimeReport() {
  // 最长时间
  let maxtime = 0;
  //最长时间对应的链接
  let maxhref = '';

  // 获取navigationEntries对象
  const entries = performance.getEntriesByType('resource');
  // 遍历资源列表
  // @ts-ignore
  entries.forEach((entry: PerformanceResourceTiming) => {
    // 判断是否为图片资源
    if (entry.initiatorType === 'img') {
      // 获取图片资源的链接
      const imgUrl = entry.name;

      const isInImgInfos = imgInfos.value.some((info) => info.href === imgUrl);

      let loadTime;

      if (isInImgInfos) {
        // 获取该图片元素的加载时间，并计算出该图片的耗时
        loadTime = entry.responseEnd - entry.fetchStart;
        console.log(`图片链接为${imgUrl}的图片耗时为：${loadTime}ms`);

        elk({
          key: 'discount_proj_img',
          num1: loadTime,
          str2: imgUrl,
          str3: window.__RavenVersion,
          str4: 'banner图片自身加载时间',
        });

        if (!maxhref || maxtime < loadTime) {
          maxtime = loadTime;
          maxhref = imgUrl;
        }
      }
    }
  });

  elk({
    key: 'discount_proj_max_img',
    num1: maxtime,
    str2: maxhref,
    str3: window.__RavenVersion,
    str4: 'banner列表图片加载时间',
  });
}

let reportTimer;

export function clearImgReportTimer() {
  clearTimeout(reportTimer);
}

function handleReport() {
  reportTimer = setTimeout(()=> {
    // 处理单图上报
    handleImgCostTimeReport();
  }, 0);
}
